import React from "react";
import AddToCartBTN from "../UI-item,viewAll,BtmSheet/AddToCartBTN";
import defaultImg from "../../../../../img/LOGO.webp";
const ItemCard = ({ items }) => {
  return items
    ? items?.map((item) => (
        <div key={item?.pID} className="card">
          <div className="card-top-image">
            {item?.mrp !== item?.sp &&
              Math.trunc(((item?.mrp - item?.sp) / item?.mrp) * 100) > 2 && (
                <span
                  style={{
                    background: "#1A5DC6",
                    padding: "1px 6px",
                    borderRadius: "8px 0px 8px 0px",
                    position: "absolute",
                    top: "0",
                    left: "0",
                    color: "#fff",
                    fontSize: "12px",
                    lineHeight: "14px", 
                    fontWeight: "700",
                  }}
                >
                  {Math.trunc(((item?.mrp - item?.sp) / item?.mrp) * 100)}% Off
                </span>
              )}
            <img
              src={
                item?.productImg
                  ? item?.productImg
                  : item?.imageURL
                  ? item?.imageURL
                  : defaultImg
              }
              loading="lazy"
              alt="product"
              width="auto"
              height="100%"
            />
          </div>
          <div className="card-body">
            <h3>{`${item.newProductName}`}</h3>
            <span className="item-weight">{item?.newProductSize}</span>
            <h5>
              <strong>{`₹${item?.sp}`}</strong>
              {item?.mrp !== item?.sp && <del>{`₹${item?.mrp}`}</del>}
            </h5>
            {item?.mrp !== item?.sp && (
              <span className="badge badge-success">{`Save ₹${Math.trunc(
                item?.mrp - item?.sp
              )}`}</span>
            )}

            <AddToCartBTN item={item} />
          </div>
        </div>
      ))
    : null;
};

export default ItemCard;
